import React from "react";

const ms = {
  overlay: {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 1060, padding: "1rem",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  modal: {
    background: "#fff", borderRadius: 14, width: "100%", maxWidth: 420,
    boxShadow: "0 24px 64px rgba(0,0,0,0.18)", overflow: "hidden",
  },
  head: {
    padding: "1rem 1.25rem", borderBottom: "1px solid #e5e7eb", background: "#fafafa",
    display: "flex", alignItems: "center", justifyContent: "space-between",
    fontSize: 15, fontWeight: 700, color: "#1a1d23",
  },
  body: { padding: "1.25rem", fontSize: 13, color: "#374151", lineHeight: 1.6 },
  foot: {
    padding: "0.875rem 1.25rem", borderTop: "1px solid #e5e7eb", background: "#fafafa",
    display: "flex", justifyContent: "flex-end", gap: 8,
  },
  btn: {
    fontSize: 12, fontWeight: 500, padding: "6px 16px", borderRadius: 6,
    border: "1px solid #d1d5db", background: "transparent", color: "#374151", cursor: "pointer",
  },
  btnDanger: {
    fontSize: 12, fontWeight: 600, padding: "6px 18px", borderRadius: 6,
    border: "none", background: "#991B1B", color: "#fff", cursor: "pointer",
  },
  closeBtn: {
    background: "none", border: "none", cursor: "pointer",
    fontSize: 20, lineHeight: 1, color: "#6b7280", padding: "0 2px",
  },
};

const UnitConfirmDelete = ({ show, onHide, unit, onConfirmDelete }) => {
  if (!show) return null;
  return (
    <div style={ms.overlay} onClick={onHide}>
      <div style={ms.modal} onClick={(e) => e.stopPropagation()}>
        <div style={ms.head}>
          Confirm Delete Unit
          <button style={ms.closeBtn} onClick={onHide}>×</button>
        </div>
        <div style={ms.body}>
          <p>Are you sure you want to delete this unit?</p>
          {unit && (
            <p style={{ color: "#6b7280" }}>
              <strong>Unit:</strong> {unit.title || unit.unitNumber || "N/A"}
            </p>
          )}
          <p style={{ color: "#991B1B", fontWeight: 500 }}>This action cannot be undone.</p>
        </div>
        <div style={ms.foot}>
          <button style={ms.btn} onClick={onHide}>Go Back</button>
          <button style={ms.btnDanger} onClick={() => onConfirmDelete(unit._id)}>Delete Unit</button>
        </div>
      </div>
    </div>
  );
};

export default UnitConfirmDelete;
